import { useCallback, useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import './App.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { Login } from './components/Login';
import { Frame } from './pages/Frame';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ErrorPage from './pages/ErrorPage';

import 'katex/dist/katex.min.css'
import { MarkdownPage } from './pages/MarkdownPage';
import MQTTExamplePage from './pages/MQTTExamplePage';
import { GraphExamplePage } from './pages/GraphExamplePage';
import { S3ExamplePage } from './pages/S3ExamplePage';
import { ApiPage } from './pages/ApiPage';
import { InfluxPage } from './pages/InfluxExamplePage';
import { DashboardPage } from './pages/DashboardPage';
import { AlgosPage } from './pages/AlgosPage';
import { DigiInsulinBatchPage } from './pages/DigiInsulinBatchPage';
import { DigiInsulinCapturePage } from './pages/DigiInsulinCapturePage';
import { DigiInsulinResultDetailPage } from './pages/DigiInsulinResultDetailPage';
import { DigiInsulinResultsPage } from './pages/DigiInsulinResultsPage';
import { authConfig } from './config/runtimeConfig';

export default function App() {
  Amplify.configure(authConfig as any);
  
  const [user, setUser] = useState<any | null>(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [userAttributes, setUserAttributes] = useState<Map<string, string> | null>(null);

  const loadAuthentication = useCallback(async () => {
    const user = await getCurrentUser()
      .catch(() => {
        setAuthLoading(false);
        setUser(null);
        setUserAttributes(null);
      });

    if (!user)
      return;

    const attrObj = await fetchUserAttributes();
    const attr: Map<string, string> = new Map(
      Object.entries(attrObj).map(([k, v]) => [k, v ?? ''])
    );

    setAuthLoading(false);
    setUserAttributes(attr);
    setUser(user);

    return () => {
      // Nothing to cancel.
    }
  }, []);

  useEffect(() => {
    loadAuthentication().catch(console.error);
  }, [loadAuthentication]);


  return (
    <>
      <script src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"></script>

      {user != null ? (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Frame userAttributes={userAttributes} onLogout={() => {
              loadAuthentication();
            }} />} errorElement={<ErrorPage />}>
              <Route index element={<Navigate to="/digiinsulin/capture" replace />} />
              <Route path='markdown' element={<MarkdownPage />} />
              <Route path='graph' element={<GraphExamplePage />} />
              <Route path='mqtt-example' element={<MQTTExamplePage />} />
              <Route path='s3-example' element={<S3ExamplePage />} />
              <Route path='api-example' element={<ApiPage />} />
              <Route path='influx-example' element={<InfluxPage />} />
              <Route path='dashboard' element={<DashboardPage />} />
              <Route path='algos' element={<AlgosPage />} />
              <Route path='digiinsulin' element={<DigiInsulinResultsPage />} />
              <Route path='digiinsulin/capture' element={<DigiInsulinCapturePage />} />
              <Route path='digiinsulin/results/:id' element={<DigiInsulinResultDetailPage />} />
              <Route path='digiinsulin/batch/:id' element={<DigiInsulinBatchPage />} />
              <Route path="*" element={<>No such page.</>} />
            </Route>
          </Routes>
        </BrowserRouter>
      ) : (<Login authLoading={authLoading} onSuccessfulAuthentication={() => {
        loadAuthentication();
      }}></Login>)}

    </>
  );
}

